import React from 'react';

import { ReactComponent as IconExclamation } from '@skippay/core/assets/icons/icon-warning-circle.svg';
import { be, bm } from '@skippay/core/utils/classUtils';

import './index.sass';

const MODULE_NAME = 'AuthError';

function AuthError(props) {
	return (
		<div className={bm(MODULE_NAME)}>
			<div className={be(MODULE_NAME, 'content')}>
				<div className={be(MODULE_NAME, 'icon')}>
					<IconExclamation />
				</div>
				{props.children}
			</div>
		</div>
	);
}

export default AuthError;
